const TEST_EMAIL_PREFIX = "lckalikow";
const CORY_TUTOR_UID = "Owl2wQhgdLP7inVoQKZL6hNK2or1";

export function filterTestStudentsForTutor({ tutorUid, students }) {
  // Only Cory gets filtering
  if (tutorUid !== CORY_TUTOR_UID) return students;

  return students.filter((student) => {
    const email = student.email?.toLowerCase() ?? "";
    return !email.startsWith(TEST_EMAIL_PREFIX);
  });
}
